<div bbKeyboardNavigation
  role="tablist"
  [id]="tabsId">
  <div *ngIf="showTabs()"
    role="tablist"
    aria-label="Beneficiary selector tabs"
    class="nav nav-tabs">
    <ng-container *ngFor="let tab of tabsConfig">
      <ng-container *ngIf="tab === beneficiaryList.CONTACTS">
        <button bbButton
          color="unstyled"
          role="tab"
          class="nav-item nav-link"
          aria-controls="contacts-tab"
          data-role="contacts-tab-item"
          aria-haspopup="listbox"
          [attr.aria-owns]="contactsListId"
          [attr.aria-selected]="activeTab === beneficiaryList.CONTACTS"
          [ngClass]="{ active: activeTab === beneficiaryList.CONTACTS }"
          (bbKeyboardClick)="setActiveTab($event, beneficiaryList.CONTACTS)"
          bbKeyboardNavigationAnchor>
          <ng-container i18n="Label|Beneficiaries tab label@@beneficiary.selector.ui.tabs.beneficiaries.label">
            Beneficiaries
          </ng-container>
          <span class="text-dark"
            *ngIf="totalContacts">({{ totalContacts }})</span>
        </button>
      </ng-container>

      <ng-container *ngIf="tab === beneficiaryList.ACCOUNTS">
        <button bbButton
          tabindex="-1"
          color="unstyled"
          role="tab"
          class="nav-item nav-link"
          aria-controls="accounts-tab"
          data-role="accounts-tab-item"
          [attr.aria-owns]="accountsListId"
          [attr.aria-selected]="activeTab === beneficiaryList.ACCOUNTS"
          [ngClass]="{ active: activeTab === beneficiaryList.ACCOUNTS }"
          (bbKeyboardClick)="setActiveTab($event, beneficiaryList.ACCOUNTS)"
          bbKeyboardNavigationAnchor>
          <ng-container i18n="Label|Own accounts tab label@@beneficiary.selector.ui.tabs.own-accounts.label">
            Own Accounts
          </ng-container>
          <span class="text-dark"
            *ngIf="totalAccounts"> ({{ totalAccounts }})</span>
        </button>
      </ng-container>

      <ng-container *ngIf="tab === beneficiaryList.CATALOGUES">
        <button bbButton
          color="unstyled"
          role="tab"
          class="nav-item nav-link"
          aria-controls="catalogues-tab"
          data-role="catalogues-tab-item"
          aria-haspopup="listbox"
          [attr.aria-owns]="cataloguesListId"
          [attr.aria-selected]="activeTab === beneficiaryList.CATALOGUES"
          [ngClass]="{ active: activeTab === beneficiaryList.CATALOGUES }"
          (bbKeyboardClick)="setActiveTab($event, beneficiaryList.CATALOGUES)"
          bbKeyboardNavigationAnchor>
          <ng-container i18n="Label|Contacts tab label@@beneficiary.selector.ui.tabs.catalog.label">
            Catalog
          </ng-container>
          <span class="text-dark"
            *ngIf="totalCatalogues">({{ totalCatalogues }})</span>
        </button>
      </ng-container>
    </ng-container>
  </div>

  <ng-container *ngIf="isDropdownOpen">
    <ng-container [ngSwitch]="activeTab">
      <div id="contacts-tab"
        *ngSwitchCase="beneficiaryList.CONTACTS">
        <!-- <bb-payments-sr-search-result-info [totalNumber]="contacts?.length">
          <span
            i18n="
              contacts search result label|label for screen
              reader@@beneficiary.selector.ui.tabs.contacts.screenReaderResultsLabel"
          >
            Contacts tab:
          </span>
        </bb-payments-sr-search-result-info> -->

        <ng-container [ngSwitch]="listState?.contacts">
          <ng-container *ngSwitchDefault>
            <cdk-virtual-scroll-viewport tabindex="-1"
              role="tabpanel"
              bbKeyboardNavigationList
              [id]="contactsListId"
              (bbBeneficiaryScroll)="onRangeChange()"
              [bbBeneficiaryScrollTotalCount]="totalContacts"
              class="bb-beneficiary-selector-ui__scroll-container">
              <!-- <div bbKeyboardNavigationItem role="option" aria-selected="false" (click)="emitManualDetails()">
                <ng-container *ngTemplateOutlet="enterAccountDetailsButton; context: { icon: 'edit' }"> </ng-container>
              </div> -->

              <ng-container *cdkVirtualFor="let contact of contacts; trackBy: trackById">
                <bb-beneficiary-contact bnBeneficiaryScrollItem
                  bbKeyboardNavigationItem
                  role="option"
                  class="bb-beneficiary-selector-ui__list-item dropdown-item"
                  (click)="selectContact(contact)"
                  [contact]="contact"
                  [displayBankName]="this.tabsConfig && this.tabsConfig.length < 2"></bb-beneficiary-contact>
              </ng-container>

              <ng-container *ngIf="listState?.contacts === listingState.FULL_LIST">
                <ng-container *ngTemplateOutlet="completeList"></ng-container>
              </ng-container>

              <ng-container *ngIf="listState?.contacts === listingState.FETCHING_FAILURE">
                <ng-container *ngTemplateOutlet="failToLoadMore"></ng-container>
              </ng-container>

              <ng-container *ngIf="listState?.contacts === listingState.FETCHING">
                <!-- <bb-loading-indicator-ui loaderSize="sm"></bb-loading-indicator-ui> -->
              </ng-container>
            </cdk-virtual-scroll-viewport>
          </ng-container>

          <ng-container *ngSwitchCase="listingState.ERROR">
            <ng-container>
              <bb-empty-state-ui [showIcon]="false"
                class="d-block bb-block bb-block--md empty-state-title"
                [title]="notFoundLabel"
                aria-label="No suggestions found"
                i18n-aria-label="Label|No suggestions found@@beneficiary.selector.ui.list.nothing-found.label">
              </bb-empty-state-ui>
            </ng-container>
          </ng-container>

          <ng-container *ngSwitchCase="listingState.EMPTY">
            <ng-container *ngTemplateOutlet="emptyListContactsTemplate"></ng-container>
          </ng-container>

          <ng-container *ngSwitchCase="listingState.NO_RESULT">
            <ng-container *ngTemplateOutlet="emptyMatchingResults"></ng-container>
          </ng-container>

          <ng-container *ngSwitchCase="listingState.LOADING">
            <ng-container *ngTemplateOutlet="loadingTemplate"></ng-container>
          </ng-container>
        </ng-container>
      </div>

      <div id="accounts-tab"
        *ngSwitchCase="beneficiaryList.ACCOUNTS">
        <bb-payments-sr-search-result-info [totalNumber]="accounts?.length">
          <span i18n="
              accounts search result label|label for screen
              reader@@beneficiary.selector.ui.tabs.account.screenReaderResultsLabel">Accounts tab:</span>
        </bb-payments-sr-search-result-info>

        <ng-container [ngSwitch]="listState?.accounts">
          <ng-container *ngSwitchDefault>
            <cdk-virtual-scroll-viewport bbKeyboardNavigationList
              tabindex="-1"
              role="tabpanel"
              [id]="accountsListId"
              (bbBeneficiaryScroll)="onRangeChange()"
              [bbBeneficiaryScrollTotalCount]="totalAccounts"
              class="bb-beneficiary-selector-ui__scroll-container">
              <!-- <div bbKeyboardNavigationItem role="option" (click)="emitManualDetails()">
                <ng-container *ngTemplateOutlet="enterAccountDetailsButton; context: { icon: 'edit' }"> </ng-container>
              </div> -->

              <ng-container *cdkVirtualFor="let account of accounts; trackBy: trackById">
                <bn-beneficiary-account bnBeneficiaryScrollItem
                  bbKeyboardNavigationItem
                  role="option"
                  class="bb-beneficiary-selector-ui__list-item dropdown-item"
                  [account]="account"
                  (click)="selectAccount(account)"></bn-beneficiary-account>
              </ng-container>

              <ng-container *ngIf="listState?.accounts === listingState.FULL_LIST">
                <ng-container *ngTemplateOutlet="completeList"></ng-container>
              </ng-container>

              <ng-container *ngIf="listState?.accounts === listingState.FETCHING_FAILURE">
                <ng-container *ngTemplateOutlet="failToLoadMore"></ng-container>
              </ng-container>

              <ng-container *ngIf="listState?.accounts === listingState.FETCHING">
                <bb-loading-indicator-ui loaderSize="sm"></bb-loading-indicator-ui>
              </ng-container>
            </cdk-virtual-scroll-viewport>
          </ng-container>

          <ng-container *ngSwitchCase="listingState.ERROR">
            <ng-container>
              <div class="bb-state-container">
                <div class="mb-3 bb-beneficiary-selector-ui__not-found-title"
                  i18n="@@beneficiary-selector-ui.not-found.title">
                  No results found
                </div>
                <div class="mb-3"
                  i18n="@@beneficiary-selector-ui.not-found.text">
                  We can't find what you are looking for. Please try a different criteria.</div>
                <div class="not-found-img"></div>
              </div>
            </ng-container>
          </ng-container>

          <ng-container *ngSwitchCase="listingState.EMPTY">
            <ng-container *ngTemplateOutlet="emptyListAccountsTemplate"></ng-container>
          </ng-container>

          <ng-container *ngSwitchCase="listingState.NO_RESULT">
            <ng-container *ngTemplateOutlet="emptyMatchingResults"></ng-container>
          </ng-container>

          <ng-container *ngSwitchCase="listingState.LOADING">
            <ng-container *ngTemplateOutlet="loadingTemplate"></ng-container>
          </ng-container>
        </ng-container>
      </div>

      <div id="catalogues-tab"
        *ngSwitchCase="beneficiaryList.CATALOGUES">
        <bb-payments-sr-search-result-info [totalNumber]="catalogues?.length">
          <span i18n="
              accounts search result label|label for screen
              reader@@beneficiary.selector.ui.tabs.account.screenReaderResultsLabel">catalogues tab:</span>
        </bb-payments-sr-search-result-info>

        <ng-container [ngSwitch]="listState?.catalogues">
          <ng-container *ngSwitchDefault>
            <cdk-virtual-scroll-viewport bbKeyboardNavigationList
              tabindex="-1"
              role="tabpanel"
              [id]="cataloguesListId"
              (bbBeneficiaryScroll)="onRangeChange()"
              [bbBeneficiaryScrollTotalCount]="totalCatalogues"
              class="bb-beneficiary-selector-ui__scroll-container">
              <!-- <div bbKeyboardNavigationItem role="option" (click)="emitManualDetails()">
                <ng-container *ngTemplateOutlet="enterAccountDetailsButton; context: { icon: 'edit' }"> </ng-container>
              </div> -->

              <ng-container *cdkVirtualFor="let catalog of catalogues; trackBy: trackById">
                <bb-beneficiary-catalog bnBeneficiaryScrollItem
                  bbKeyboardNavigationItem
                  role="option"
                  class="bb-beneficiary-selector-ui__list-item dropdown-item py-0"
                  [catalog]="catalog"
                  (click)="selectCatalog(catalog)">
                </bb-beneficiary-catalog>
              </ng-container>

              <ng-container *ngIf="listState?.catalogues === listingState.FULL_LIST">
                <ng-container *ngTemplateOutlet="completeList"></ng-container>
              </ng-container>

              <ng-container *ngIf="listState?.catalogues === listingState.FETCHING_FAILURE">
                <ng-container *ngTemplateOutlet="failToLoadMore"></ng-container>
              </ng-container>

              <ng-container *ngIf="listState?.catalogues === listingState.FETCHING">
                <bb-loading-indicator-ui loaderSize="sm"></bb-loading-indicator-ui>
              </ng-container>
            </cdk-virtual-scroll-viewport>
          </ng-container>

          <ng-container *ngSwitchCase="listingState.ERROR">
            <ng-container>
              <div class="bb-state-container">
                <div class="mb-3 bb-beneficiary-selector-ui__not-found-title"
                  i18n="@@beneficiary-selector-ui.not-found.title">
                  No results found
                </div>
                <div class="mb-3"
                  i18n="@@beneficiary-selector-ui.not-found.text">
                  We can't find what you are looking for. Please try a different criteria.</div>
                <div class="not-found-img"></div>
              </div>
            </ng-container>
          </ng-container>

          <ng-container *ngSwitchCase="listingState.EMPTY">
            <ng-container *ngTemplateOutlet="emptyListCATALOGUESTemplate"></ng-container>
          </ng-container>

          <ng-container *ngSwitchCase="listingState.NO_RESULT">
            <ng-container *ngTemplateOutlet="emptyMatchingResults"></ng-container>
          </ng-container>

          <ng-container *ngSwitchCase="listingState.LOADING">
            <ng-container *ngTemplateOutlet="loadingTemplate"></ng-container>
          </ng-container>
        </ng-container>
      </div>
    </ng-container>
  </ng-container>
</div>

<!-- Empty lists -->
<ng-template #emptyListAccountsTemplate>
  <ng-container>
    <bb-empty-state-ui [showIcon]="false"
      class="d-block bb-block bb-block--md empty-state-title"
      [title]="notFoundLabel"
      aria-label="No suggestions found"
      i18n-aria-label="Label|No suggestions found@@beneficiary.selector.ui.list.nothing-found.label">
    </bb-empty-state-ui>
  </ng-container>
</ng-template>

<ng-template #emptyListContactsTemplate>
  <ng-container>
    <bb-empty-state-ui [showIcon]="false"
      class="d-block bb-block bb-block--md empty-state-title"
      [title]="notFoundLabel"
      aria-label="No suggestions found"
      i18n-aria-label="Label|No suggestions found@@beneficiary.selector.ui.list.nothing-found.label">
    </bb-empty-state-ui>
  </ng-container>
</ng-template>

<ng-template #emptyListCATALOGUESTemplate>
  <ng-container>
    <bb-empty-state-ui [showIcon]="false"
      class="d-block bb-block bb-block--md empty-state-title"
      [title]="notFoundLabel"
      aria-label="No suggestions found"
      i18n-aria-label="Label|No suggestions found@@beneficiary.selector.ui.list.nothing-found.label">
    </bb-empty-state-ui>
  </ng-container>
</ng-template>

<ng-template #loadingTemplate>
  <div class="bb-state-container">
    <bb-loading-indicator-ui loaderSize="md"></bb-loading-indicator-ui>
  </div>
</ng-template>

<ng-template #enterAccountDetailsButton
  let-icon="icon">
  <div *ngIf="canEditManually"
    data-role="enter-data-manually"
    class="bb-beneficiary-selector-ui__enter-details dropdown-item">
    <div class="bb-create-beneficiary-account-menuitem">
      <div class="bb-stack">
        <ng-container *ngTemplateOutlet="enterAccountDetails; context: { type: icon }"></ng-container>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #enterAccountDetails
  let-type="type">
  <bb-icon-ui name="{{ type }}"
    size="l"
    class="bb-stack__item"></bb-icon-ui>
  <span class="bb-stack__item"
    i18n="@@beneficiary.selector.ui.list.enter-details-manually.button">
    Enter details manually
  </span>
</ng-template>

<ng-template #emptyMatchingResults>
  <div class="bb-state-container">
    <bb-empty-state-ui [showIcon]="false"
      class="d-block bb-block bb-block--md empty-state-title"
      [title]="notFoundLabel"
      aria-label="No suggestions found"
      i18n-aria-label="Label|No suggestions found@@beneficiary.selector.ui.list.nothing-found.label">
    </bb-empty-state-ui>


    <div *ngIf="canEditManually"
      class="bb-state-container__footer">
      <button bbButton
        type="button"
        buttonSize="md"
        color="link-text"
        class="bb-beneficiary-selector-ui__enter-details"
        data-role="enter-data-manually"
        (bbKeyboardClick)="emitManualDetails()">
        <ng-container *ngTemplateOutlet="enterAccountDetails; context: { type: 'add' }"></ng-container>
      </button>
    </div>
  </div>
</ng-template>

<ng-template #completeList>
  <div data-role="all-items-loaded"
    class="bb-create-beneficiary-account-menuitem bb-stack bb-stack--center bb-text-support"
    i18n="@@beneficiary-selector-ui.loaded-all-items">
    All items are loaded.
  </div>
</ng-template>

<ng-template #failToLoadMore>
  <button type="button"
    role="menuitem"
    data-role="fail-to-load-more-try-again"
    (click)="refreshList()"
    class="dropdow-item bb-stack bb-stack--center bb-text-danger dropdown-item">
    <bb-icon-ui color="danger"
      name="error-outline"
      class="bb-stack__item bb-stack__item--spacing-sm"></bb-icon-ui>

    <span class="bb-stack__item"
      i18n="@@beneficiary-selector-ui.fail-to-fetch">
      Loading failed. Click here to try again.
    </span>
  </button>
</ng-template>
